import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App bg-brand-bg text-white min-h-screen">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#ffffff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
